/****************************************************
 * Module Name:  addPacketAssignModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import Constants from "../../utility/constants";
import Select from "react-select";
import "bootstrap/dist/css/bootstrap.min.css";
import { Box, Button, Tooltip } from "@mui/material";
import CommonSnackbar from "../common/commonSnackBar";
import DepartmentProxy from "../../utility/proxy/manager/manufacturingProxy/departmentProxy";
import { LoadingButton } from "@mui/lab";
import logo from '../../images/pansuriya.jpg'
import SaveIcon from '@mui/icons-material/Save';
import CircularProgress from "@mui/material/CircularProgress";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import UserDetailModal from "../operations/userDetailModal";
import UserProcessMasterProxy from "../../utility/proxy/manager/manufacturingProxy/userProcessMasterProxy";

export default class AddPacketAssignModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            departmentGroupUser: "",

            showError: false,
            userOptions: [],
            showUserLoadSpinner: true,
            showUserDetailModal: false,

            newProcess: "",
            processOptions: [],
            processOptionMap: new Map(),
        };
        this.getAllProcessData();
        this.getAllUser(false);
    }

    getAllUser = (bAnimateSpinner) => {
        bAnimateSpinner && this.setState({ showUserLoadSpinner: true });
        DepartmentProxy.GetSingleDepartmentUsers([Constants.loggedInUser.id], (response) => {
            if (response) {
                this.setAllUserData(response)
            } else {
                this.setState({
                    showError: true
                })
            }
        }
        );
    };

    setAllUserData = (response) => {
        let optionsArray = [];
        response.map((data) => {
            let option = {
                value: data.userId + " | " + data.departmentId,
                label: data.userName
            };
            optionsArray.push(option);

            return true;
        });
        this.setState({
            userOptions: optionsArray,
            departmentGroupUser: optionsArray.length > 0 ? optionsArray[0] : '',
            newProcess: optionsArray.length > 0 ? this.state.processOptionMap.get(parseInt(optionsArray[0].value.split(" | ")[0].trim(), 10)) : '',
            showUserLoadSpinner: false,
        });
    };

    getAllProcessData = () => {
        UserProcessMasterProxy.GetAllUserProcess((response) =>
            this.setAllProcessData(response)
        );
    };

    setAllProcessData = (response) => {
        const processMap = new Map();

        response.forEach(user => {
            if (user.userid && Array.isArray(user.assignedprocess)) {
                processMap.set(user.userid, user.assignedprocess);
            }
        });

        this.setState({
            processOptionMap: processMap,
        });
    };

    handleUserChange = (selectedOption) => {
        let processOptions = [];
        this.state.processOptionMap.forEach((value, key) => {
            if (key === parseInt(selectedOption.value.split(" | ")[0].trim(), 10)) {
                value.forEach(process => {
                    let processOption = {
                        value: process.id,
                        label: process.name,
                    };
                    processOptions.push(processOption);
                });
            }
        });
        this.setState({
            departmentGroupUser: selectedOption,
            processOptions: processOptions,
            newProcess: processOptions.length > 0 ? processOptions[0] : ''
        });
    };

    prepareData = () => {
        let arr = []
        this.props.sourceData.map((item) => {
            let obj = {}
            obj.kapanid = item.kapanid
            obj.packetid = item.packetid
            arr.push(obj)
            return true;
        })

        return arr;
    }

    handleSave = () => {
        let data = {
            userid: Constants.loggedInUser.id,
            departmentid: this.state.departmentGroupUser.value.split(' | ')[1],
            departmentgroupid: undefined,
            headid: this.state.departmentGroupUser.value.split(' | ')[0],
            processid: this.state.newProcess != null ? this.state.newProcess.value : null,
            date: new Date().toISOString(),
            kapanspacket: this.prepareData()
        };

        let headData = this.state.newDepartmentGroupHead;

        if (this.props.handleSave) {
            if (this.props.handleValidation) {
                if (this.props.handleValidation(data, headData))
                    this.props.handleSave(data, headData);
                else
                    this.setState({
                        showError: true,
                    });
            } else this.props.handleSave(data, headData);
        }
    };

    closeErrorDialog = () => {
        this.setState({
            showError: false,
        });
    };

    render() {
        return (
            <Box>
                <CommonSnackbar
                    show={this.state.showError}
                    message={
                        <Box>
                            Packet Assign validation Failed
                            <br /> Please enter complete data
                        </Box>
                    }
                    variant={"error"}
                    autoHide={false}
                    handleClose={this.closeErrorDialog}
                    title="Validation Failure"
                />
                {this.state.showUserDetailModal ? (
                    <UserDetailModal
                        show={true}
                        handleClose={() => this.setState({ showUserDetailModal: false })}
                        handleSelect={(selectedOption) => {
                            const selectedCustomers = this.state.userOptions.filter(opt => {
                                const optId = parseInt(opt.value.split(" | ")[0].trim(), 10);
                                return selectedOption.includes(optId);
                            });
                            this.setState({
                                departmentGroupUser: selectedCustomers[0],
                                showUserDetailModal: false
                            });
                        }}
                        userids={this.state.userOptions.map(cust => cust.value.split("|")[0].trim())}
                        selectedIds={
                            this.state.departmentGroupUser && this.state.departmentGroupUser.value
                                ? [parseInt(this.state.departmentGroupUser.value.split(" | ")[0].trim(), 10)]
                                : []
                        }
                        usertype={"U"}
                        loading={this.state.showUserDetailModal}
                        isMulti={false}
                    />
                ) : null}
                <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <img
                                src={logo}
                                height="40pt"
                                width="40pt"
                                alt={Constants.COMPANY_SITE}
                            />
                            &nbsp;&nbsp; Assign Packet
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <center>
                            <table style={{ width: "100%" }}>
                                <tbody>
                                    <tr>
                                        <td>
                                            <Form.Label>User</Form.Label>
                                        </td>
                                        <td style={{ width: "70%" }}>
                                            <Select menuPlacement="auto"
                                                blurInputOnSelect={false}
                                                getOptionLabel={(option) => option.label}
                                                getOptionValue={(option) => option.value}
                                                value={this.state.departmentGroupUser}
                                                isSearchable={true}
                                                closeMenuOnSelect={true}
                                                name="User"
                                                menuPortalTarget={document.body}
                                                styles={Constants.Styles}
                                                options={this.state.userOptions}
                                                onChange={(selectedOption) =>
                                                    this.handleUserChange(selectedOption)
                                                }
                                            />
                                        </td>
                                        <td>
                                            <Tooltip title="View More Data">
                                                <OpenInNewIcon
                                                    style={{ fontSize: "20px", cursor: "pointer", marginLeft: "13px" }}
                                                    color="action"
                                                    onClick={() => {
                                                        this.setState({
                                                            showUserDetailModal: true,
                                                        });
                                                    }}
                                                />
                                            </Tooltip>
                                        </td>
                                        <td>
                                            {this.state.showUserLoadSpinner ? (
                                                <CircularProgress
                                                    size="1em"
                                                    sx={{ mt: 1, ml: 2 }}
                                                />
                                            ) : (
                                                <Tooltip title="Reload">
                                                    <RefreshOutlinedIcon
                                                        color="primary"
                                                        fontSize="medium"
                                                        onClick={() => this.getAllUser(true)}
                                                        sx={{
                                                            cursor: "pointer",
                                                            mt: 1,
                                                        }}
                                                    />
                                                </Tooltip>
                                            )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label>Process</Form.Label>
                                        </td>
                                        <td
                                            style={{
                                                width: "70%",
                                            }}
                                        >
                                            <Select menuPlacement="auto"
                                                blurInputOnSelect={false}
                                                value={this.state.newProcess}
                                                isSearchable={true}
                                                name="Process"
                                                styles={Constants.Styles}
                                                menuPortalTarget={document.body}
                                                options={this.state.processOptions}
                                                onChange={(selectedOption) =>
                                                    this.setState({ newProcess: selectedOption })
                                                }
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </center>
                    </Modal.Body>
                    <Modal.Footer>
                        <LoadingButton
                            loading={this.props.loading}
                            loadingPosition="start"
                            startIcon={<SaveIcon />}
                            variant="contained"
                            onClick={() => this.handleSave()}
                            disabled={!this.state.departmentGroupUser}
                            sx={{ mr: 1 }}
                        >
                            Save
                        </LoadingButton>
                        <Button
                            variant="contained"
                            color="error"
                            onClick={this.props.handleClose}
                            disabled={this.props.loading}
                        >
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Box>
        );
    }
}
